import React from 'react';
import { makeStyles } from 'utils/makeStylesAdapter';
import { Button } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { colors, lightTheme } from 'utils/colorsSteps';
import { useParameterKeys } from 'hooks/useParameterKeys';

const ButtonConsensus = props => {
  const {
    color,
    size,
    margin,
    backgroundColor,
    hovercolor,
    title,
    onClick,
    className,
    width,
    ...rest
  } = props;

  const { applyLightTheme } = useParameterKeys();

  const isWhiteColor = color && ['#ffffff', '#fff'].includes(color.toLowerCase());
  const effectiveColor = applyLightTheme && isWhiteColor ? lightTheme.fontColor : color;

  const isNavyBg = backgroundColor && backgroundColor.toLowerCase() === colors.navBar.toLowerCase();
  const effectiveBg = applyLightTheme && isNavyBg ? lightTheme.backgroundColor : backgroundColor;

  const isNavyHover = hovercolor && hovercolor.toLowerCase() === colors.navBar.toLowerCase();
  const effectiveHover = applyLightTheme && isNavyHover ? lightTheme.backgroundColor : hovercolor;

  const useStyles = makeStyles(theme => ({
    root: {
      backgroundColor: effectiveBg,
      '&:hover': {
        backgroundColor: effectiveHover,
      },
      color: effectiveColor,
      borderRadius: 25,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    // TODO
    container: {
      //margin: theme.spacing(1),
      margin: margin,
      width: width || undefined,
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0.3),
        width: '100%',
      },
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Button
        {...rest}
        className={clsx(classes.root, className)}
        variant="contained"
        onClick={onClick}
        size={size}
      >
        {title}
        {/* {children ? children : null} */}
      </Button>
    </div>
  );
};

ButtonConsensus.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  hovercolor: PropTypes.string,
  color: PropTypes.string,
  margin: PropTypes.number,
  size: PropTypes.string,
  width: PropTypes.number,
};

ButtonConsensus.defaultProps = {
  backgroundColor: colors.navBar,
  hovercolor: colors.navBar,
  color: '#ffffff',
  margin: 8,
  size: 'large',
};

export default ButtonConsensus;
